import {styled} from "@mui/material";


const Wrapper = styled('div')({});

const NotFound = () => {
  return (
    <Wrapper>

    </Wrapper>
  );
};

export default NotFound;
